var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.9943C15.9944 6.38006 15.7522 5.79281 15.3257 5.35979L10.4229 0.339503C10.2087 0.122054 9.91907 0 9.61714 0C9.31522 0 9.02556 0.122054 8.81143 0.339503C8.70431 0.448038 8.61929 0.577165 8.56127 0.719437C8.50325 0.861709 8.47337 1.01431 8.47337 1.16843C8.47337 1.32256 8.50325 1.47516 8.56127 1.61743C8.61929 1.7597 8.70431 1.88883 8.81143 1.99736L12.5714 5.82679H1.14286C0.839753 5.82679 0.549063 5.94979 0.334735 6.16874C0.120408 6.38769 0 6.68465 0 6.9943C0 7.30394 0.120408 7.6009 0.334735 7.81985C0.549063 8.0388 0.839753 8.1618 1.14286 8.1618H12.5714L8.81143 12.0029C8.59622 12.2212 8.47472 12.5179 8.47365 12.8277C8.47258 13.1375 8.59203 13.4351 8.80571 13.6549C9.0194 13.8748 9.30983 13.9989 9.6131 14C9.91638 14.0011 10.2077 13.8791 10.4229 13.6608L15.3257 8.64048C15.755 8.20459 15.9974 7.61258 16 6.9943Z",
    fill: "#2263D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f70ad4b17d80d88f3f0db75250b45595.svg";
export { ForwardRef as ReactComponent };